export default {"src":"/_next/static/media/favourites-icon.7a00332b.svg","height":18,"width":21};